import React from "react";
import PropTypes from "prop-types";
import TnelectionHeader2026 from "../rows/tnelection-header-2026";
import styles from "./tn-election.m.css";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import { PAGE_TYPE } from "../../constants";
import StoryCardVertical from "../atoms/story-card-vertical";
import { get } from "lodash";
import ConstituencySearchBar from "../atoms/constituency-searchbar";
import ElectionMapComponent from "./vikatan-election-map";

const StoryList = ({ stories }) => {
  return (
    <React.Fragment>
      {stories.length > 0 ? (
        stories.map((story, idx) => (
          <div key={idx} className={styles["story-card"]}>
            <StoryCardVertical story={story} key={story.id} />
          </div>
        ))
      ) : (
        <h3 className={styles["no-results"]}>No results found</h3>
      )}
    </React.Fragment>
  );
};

StoryList.propTypes = {
  stories: PropTypes.arrayOf(StoryCardVertical.propTypes.story)
};

const ConstituencyElectionPage = ({ data }) => {
  const stories = get(data, ["stories"], null);

  React.useEffect(() => {
    GA.registerPageView(PAGE_TYPE.TN_ELECTION_PAGE, { collection: data.collection });
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: data.collection });
    PGAD.loadScript();
  }, []);
  // const metaImg = data.collection.metadata["cover-image"]["cover-image-s3-key"];

  return (
    <React.Fragment>
      <div className={styles["election-page-wrapper"]}>
        <TnelectionHeader2026 showMenu={true} />
        <div className="container">
          {/* <div className={styles["election-header"]}>
            <img src={`https://media.vikatan.com/${metaImg}`} />
          </div> */}

          <div className={styles["outer-wrapper"]}>
            <div className={styles["form-txt"]}>
              <h1>
                <span>தொகுதி</span>
                <span>360</span>
              </h1>
            </div>
            <div className={styles["map-search-wrapper"]}>
              <div className={styles["map-outer"]}>
                <ElectionMapComponent mainelectionPage={true} />
              </div>
              <div className={styles["search-bar-outer"]}>
                <ConstituencySearchBar mainelectionPage={true} />
              </div>
            </div>
          </div>
          {/* Stories Section (Outside grey wrapper) */}
          {stories &&
            stories.length > 0 && (
              <div className={styles["stories-section"]}>
                <h2 className={styles["section-title"]}>{`சட்டமன்ற தேர்தல் 2026`}</h2>
                <div className={styles["stories-grid"]}>
                  <StoryList stories={stories} />
                </div>
              </div>
            )}
        </div>
      </div>
    </React.Fragment>
  );
};
export { ConstituencyElectionPage };

ConstituencyElectionPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
